import { Backdrop, CircularProgress } from '@mui/material';
import { FC } from 'react';

interface CommonLoaderModel {
  isLoading: boolean;
}
const CommonLoader: FC<CommonLoaderModel> = ({ isLoading }) => {
  return (
    <Backdrop sx={{ zIndex: 10 }} open={isLoading}>
      <CircularProgress size={56} disableShrink thickness={3} color='primary' />
    </Backdrop>
  );
};

export default CommonLoader;
